// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3mwA_","header":"PatientQuestionnaire_header__1U64g","info":"PatientQuestionnaire_info__2zwwO"};